// ES module live binding:
// `export let` を使うことで、setCompanyId() 呼び出し後に
// 各 import 先が COMPANY_ID を読むと常に最新値が返る。
export let COMPANY_ID = localStorage.getItem("companyId") || "";

export const setCompanyId = (id) => {
  COMPANY_ID = id;
  localStorage.setItem("companyId", id);
};

export const clearCompanyId = () => {
  COMPANY_ID = "";
  localStorage.removeItem("companyId");
};
